import { UserRole } from "../types/auth.types";

/**
 * Default CRM role offered when a sales position's holder is invited (2026-10-27):
 * reps -> MSR (MSR portal, schedule from the position's Sales Reps lists),
 * territory / regional managers -> their own roles (2026-10-29), everything else -> Staff.
 * position_type is free text in the DB, so it is compared normalised.
 */
export function defaultInviteRole(
  positionType: string | null | undefined,
): UserRole {
  const t = String(positionType ?? "")
    .trim()
    .toLowerCase();
  if (t === "sales_rep") {
    return UserRole.MSR;
  }
  // 2026-10-29: territory / regional managers get their own roles (mig 1240/1241), no longer Manager.
  if (t === "territory_manager") {
    return UserRole.TERRITORY_MANAGER;
  }
  if (t === "regional_manager") {
    return UserRole.REGIONAL_MANAGER;
  }
  return UserRole.STAFF;
}
